export const midBreakPoint = 768;